import { CompanyAPI } from '@api';

const getCompanyTollsInfo = () => CompanyAPI.getCompanyTollsInfo()
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getCompanyTollsInfo };
